module.exports = __webpack_public_path__ + "static/icon-money.2f62499a.png";


//////////////////
// WEBPACK FOOTER
// ./app/resource/page/index/views/images/icon-money.png
// module id = 1017
// module chunks = 2